import { create } from "zustand";
export const accountAttributionStore = create((set) => ({
    byAccountId: {},
    byEmail: {},
    currentAccountId: undefined,
    mergeIdentities: (entries) => set((s) => ({
        byAccountId: { ...s.byAccountId, ...entries },
    })),
    mergeEmailToAccountId: (entries) => set((s) => ({
        byEmail: { ...s.byEmail, ...entries },
    })),
    setCurrentAccountId: (accountId) => set((s) => {
        // Idempotent: avoid a re-render when the slot already matches.
        // Subscribers (like `useCurrentAccountId`) memo on this slice;
        // an unconditional set would still cycle them through render.
        if (s.currentAccountId === accountId)
            return s;
        return { currentAccountId: accountId };
    }),
}));
